var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmnisend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 350 130",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".ost0{fill:#555c66}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_854_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    className: "ost0",
    d: "M61.3 77.8c-5.3 0-9-4.4-9-10.2s3.7-10.2 9-10.2 9 4.4 9 10.2c0 5.7-3.6 10.2-9 10.2m0-25.3c-7.4 0-14.1 6.3-14.1 15s6.8 15 14.1 15c7.4 0 14.1-6.3 14.1-15 .1-8.7-6.7-15-14.1-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    className: "ost0",
    d: "M113.8 52.5c-4.5 0-7.4 2.5-9 4.7h-1c-1.7-2.4-4.4-4.7-8.2-4.7-3.9 0-6.4 2.3-7.5 3.6h-.8l-1-3.3h-3.4v29.4h5.2V65.5c0-5.4 3.3-8.5 7.1-8.5 5.1 0 5.8 5.4 5.8 11.1v14.2h5.2V65.1c.2-5.2 3.4-8.1 7.1-8.1 5.1 0 5.8 5.4 5.8 11.1v14.2h5.2v-16c-.2-8.1-3.7-13.8-10.5-13.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    className: "ost0",
    d: "M146.4 52.5c-4.9 0-7.5 2.4-8.6 3.6h-.8l-1.1-3.4h-3.4v29.4h5.2V65.5c0-5.2 3.5-8.5 7.9-8.5 5.8 0 6.7 5.8 6.7 11.1v14.2h5.2v-16c0-8.2-3.7-13.8-11.1-13.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    className: "ost0",
    d: "M192.8 64.9c-2.9-.8-5.7-1.7-5.7-4.4 0-2.4 2.1-3.9 4.8-3.9 3.1 0 5.4 2 5.4 4.2h4.8c0-4.1-3.6-8.4-10.2-8.4-5.4 0-9.7 2.9-9.7 8.2 0 5.9 5.5 7.5 9.5 8.5 3.2.9 6.1 1.8 6.1 4.8 0 2.9-2.6 4.2-5.4 4.2-3.2 0-6.4-1.9-6.4-5.5h-4.8c0 5.4 4.4 9.8 11.2 9.8 5.8 0 10.2-3.2 10.2-8.7.2-6.1-5.3-7.6-9.8-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_128_",
    className: "ost0",
    d: "M214.2 64.4c.9-4.7 4.2-7.7 8.6-7.7 4.4 0 7.4 3.2 8.1 7.7h-16.7zm8.7-12c-7.4 0-14 5.7-14 14.8 0 9.2 6.6 15.3 14 15.3 5.4 0 10.4-3.2 12.7-8.5h-5.4c-1.4 2.3-3.9 3.8-7.3 3.8-5.1 0-8.5-3.4-9-8.9h22.3c.7-11.3-6.2-16.5-13.3-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    className: "ost0",
    d: "M257.4 52.5c-4.9 0-7.5 2.4-8.6 3.6h-.8l-1.1-3.4h-3.4v29.4h5.2V65.5c0-5.2 3.5-8.5 7.9-8.5 5.8 0 6.7 5.8 6.7 11.1v14.2h5.2v-16c0-8.2-3.7-13.8-11.1-13.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_124_",
    className: "ost0",
    d: "M289.4 77.7c-4.4 0-8.8-3.8-8.8-10.2 0-6.4 4.4-10.2 8.8-10.2 3.9 0 8.4 2.9 8.4 10.2 0 7.2-4.6 10.2-8.4 10.2zm8.4-37.3v16.8c-1.9-2.8-4.8-4.7-8.9-4.7-7.5 0-13.6 6.3-13.6 15s6.1 15 13.6 15c3.8 0 6.6-1.6 8.4-4.1h.9l1.1 3.8h3.4V40.4h-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    className: "ost0",
    d: "M164 47.8v4.5c4.1 1.2 4.7 5.4 4.7 10.9v19.1h5.2V61.4c0-8.1-3.2-13-9.9-13.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_122_",
    className: "ost0",
    d: "M170.1 35c-2.1 0-3.8 1.7-3.8 3.8s1.7 3.8 3.8 3.8 3.8-1.7 3.8-3.8c0-2.1-1.7-3.8-3.8-3.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmnisend);
export default __webpack_public_path__ + "static/media/omnisend.52ac88ce0ef75a1cdc1ecaccaf119888.svg";
export { ForwardRef as ReactComponent };